var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"login",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":"","sm9":"","md6":"","lg5":""}},[_c('login-component')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }